import React, { ReactNode, useState, useEffect } from "react";

interface ResponsiveProps {
  minWidth?: number;
  maxWidth?: number;
  children: ReactNode;
}

type Breakpoint = {
  onlyMobile: { minWidth: number; maxWidth: number };
  onlyTablet: { minWidth: number; maxWidth: number };
  onlyComputer: { minWidth: number; maxWidth: number };
  onlyLargeScreen: { minWidth: number; maxWidth: number };
  onlyWidescreen: { minWidth: number; maxWidth: number };
};

const Responsive: React.FC<ResponsiveProps> & Breakpoint = ({ minWidth, maxWidth, children }) => {
  const [isMatched, setIsMatched] = useState<boolean>(true);

  useEffect(() => {
    const handleResize = () => {
      if (minWidth !== undefined && maxWidth !== undefined) {
        setIsMatched(window.innerWidth >= minWidth && window.innerWidth <= maxWidth);
      } else if (minWidth !== undefined) {
        setIsMatched(window.innerWidth >= minWidth);
      } else if (maxWidth !== undefined) {
        setIsMatched(window.innerWidth <= maxWidth);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [minWidth, maxWidth]);

  return isMatched ? <>{children}</> : null;
};

Responsive.onlyMobile = { minWidth: 0, maxWidth: 767 };
Responsive.onlyTablet = { minWidth: 768, maxWidth: 991 };
Responsive.onlyComputer = { minWidth: 992, maxWidth: 1199 };
Responsive.onlyLargeScreen = { minWidth: 1200, maxWidth: 1919 };
Responsive.onlyWidescreen = { minWidth: 1920, maxWidth: Infinity };

export default Responsive;
